import { useTranslation } from 'react-i18next';
import { Textfield } from '@digdir/designsystemet-react';

import { useOmBoligenFormContext } from '../utils';
import { useOmBoligenValidation } from '../hooks/useOmBoligenValidation';
import { parseNorwegianFormattedNumber } from '../../../../../../utils/utils';

export const OppvarmetBruksarealInput = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();
  const { validateOppvarmetBruksareal } = useOmBoligenValidation();

  const error = formState.errors.bygginfo?.heatedArea?.message;

  return (
    <Textfield
      type="text"
      inputMode="decimal"
      label={t('register.bygningsdetaljer.totalOppvarmetBRA.label')}
      suffix={t('register.solar.form.suffix.sqm')}
      error={error}
      {...register('bygginfo.heatedArea', {
        setValueAs: (value) => parseNorwegianFormattedNumber(value),
        validate: validateOppvarmetBruksareal,
      })}
    />
  );
};
